<ng-container [ngSwitch]="status">
  <ng-container
    *ngSwitchCase="'commission'"
    [ngTemplateOutlet]="commissionTemplate"
  ></ng-container>
  <ng-container
    *ngSwitchDefault
    [ngTemplateOutlet]="contractTemplate"
  ></ng-container>
</ng-container>

<ng-template #contractTemplate>
  <div class="header">
    <h1>{{ statusMessage }}</h1>
    <mat-chip-list *ngIf="statusMessage">
      <mat-chip color="primary" selected class="count-chip">{{
        contractArray.length || 0
      }}</mat-chip>
    </mat-chip-list>
  </div>
  <div class="table-container">
    <div class="content">
      <div class="filter">
        <mat-form-field appearance="standard">
          <mat-label>Filter Contracts</mat-label>
          <input
            matInput
            (keyup)="filterContracts($event)"
            #input
            placeholder="ex. John Doe"
          />
        </mat-form-field>
      </div>

      <table
        mat-table
        [dataSource]="dataSource"
        class="table"
        matSort
        fixedLayout="true"
      >
        <ng-container matColumnDef="contractId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Contract ID</th>
          <td mat-cell *matCellDef="let contract">
            {{ contract.contractId || "n/a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="notes">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Notes</th>
          <td mat-cell *matCellDef="let contract">
            {{ contract.notes || "n/a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="customerName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Customer Name
          </th>
          <td mat-cell *matCellDef="let contract">
            {{ contract.customerName || "n/a" | titlecase }}
          </td>
        </ng-container>
        <ng-container matColumnDef="jobaddress">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Job Address</th>
          <td mat-cell *matCellDef="let contract">
            {{ contract.jobaddress || "n/a" | titlecase }}
          </td>
        </ng-container>
        <ng-container matColumnDef="contractDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Contract Date
          </th>
          <td mat-cell *matCellDef="let contract">
            {{ contract.contractDate | date : "shortDate" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="soldDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Sold Date</th>
          <td mat-cell *matCellDef="let contract">
            {{
              contract.soldDate
                ? (contract.soldDate | date : "shortDate")
                : "n/a"
            }}
          </td>
        </ng-container>
        <ng-container matColumnDef="estimator">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Sales Rep</th>
          <td mat-cell *matCellDef="let contract">
            {{ contract.estimator || "n/a" | titlecase }}
          </td>
        </ng-container>
        <ng-container matColumnDef="contractTotal">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Total $</th>
          <td mat-cell *matCellDef="let contract">
            {{ contract.contractTotal | currency : "USD" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="zoneName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Zone</th>
          <td mat-cell *matCellDef="let contract">
            {{ contract.zoneName || "n/a" | titlecase }}
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>

        <tr
          class="mat-row"
          *matNoDataRow
          [ngStyle]="{ 'text-align': 'center' }"
        >
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            No matching contracts found
          </td>
        </tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="goToContract(row)"
        ></tr>
      </table>

      <div *ngIf="isLoading" class="spinner">
        <mat-spinner color="accent" mode="indeterminate"></mat-spinner>
      </div>

      <mat-paginator
        [pageSize]="100"
        [pageSizeOptions]="[10, 50, 100, 150, 500]"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  </div>
</ng-template>

<ng-template #commissionTemplate>
  <div class="header">
    <h1>{{ statusMessage }}</h1>
    <mat-chip-list *ngIf="statusMessage">
      <mat-chip color="primary" selected class="count-chip">{{
        unlockedCommissionsArray.length || 0
      }}</mat-chip>
    </mat-chip-list>
  </div>
  <div class="table-container">
    <div class="content">
      <div class="filter">
        <mat-form-field appearance="standard">
          <mat-label>Filter Commissions</mat-label>
          <input
            matInput
            (keyup)="filterCommissions($event)"
            #input
            placeholder="ex. John Doe"
          />
        </mat-form-field>
      </div>

      <table
        mat-table
        [dataSource]="commissionDataSource"
        class="table"
        matSort
        fixedLayout="true"
      >
        <ng-container matColumnDef="contractId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Contract ID</th>
          <td mat-cell *matCellDef="let commission">
            {{ commission.contractId || "n/a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="customerName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Customer Name
          </th>
          <td mat-cell *matCellDef="let commission">
            {{ commission.customerName || "n/a" | titlecase }}
          </td>
        </ng-container>
        <ng-container matColumnDef="contractTotal">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Total $</th>
          <td mat-cell *matCellDef="let commission">
            {{ commission.contractTotal | currency : "USD" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="approvalDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Approval Date
          </th>
          <td mat-cell *matCellDef="let commission">
            {{
              commission.approvalDate
                ? (commission.approvalDate | date : "shortDate")
                : "n/a"
            }}
          </td>
        </ng-container>
        <ng-container matColumnDef="isException">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Is Exception
          </th>
          <td mat-cell *matCellDef="let commission">
            {{ commission.isException ? "Yes" : "No" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="estimatorName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Estimator Name
          </th>
          <td mat-cell *matCellDef="let commission">
            {{ commission.estimatorName || "n/a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="insideSalesName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Inside Sales Name
          </th>
          <td mat-cell *matCellDef="let commission">
            {{ commission.insideSalesName || "n/a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="serviceName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Service Name
          </th>
          <td mat-cell *matCellDef="let commission">
            {{ commission.serviceName || "n/a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="foremanName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Foreman Name
          </th>
          <td mat-cell *matCellDef="let commission">
            {{ commission.foremanName || "n/a" }}
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>

        <tr
          class="mat-row"
          *matNoDataRow
          [ngStyle]="{ 'text-align': 'center' }"
        >
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            No unlocked commissions found
          </td>
        </tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="goToCommission(row)"
        ></tr>
      </table>

      <div *ngIf="isLoading" class="spinner">
        <mat-spinner color="accent" mode="indeterminate"></mat-spinner>
      </div>

      <mat-paginator
        [pageSize]="100"
        [pageSizeOptions]="[10, 50, 100, 150, 500]"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  </div>
</ng-template>
